import {
  LIFE_PENSION_PLAN_PERMISSION_ENUM,
  PENSION_PLAN_PERMISSION_ENUM,
  PERSON_PERMISSION_ENUM,
  PERSONAL_DATA_PERMISSION_ENUM
} from './opin-consent.enum';

interface ITpp {
  name: string;
  logoUrl: string;
}

class PermissionInfo {
  title: string;
  details: string[];
}

class PermissionDetail {
  title: string;
  permissions: PermissionInfo[];
}

export class Participant {
  name: string;
  logoUrl: string;
}

class PersonalData {
  name: string;
  cpf: string;
  status: boolean;
  permissions: (keyof typeof PERSONAL_DATA_PERMISSION_ENUM)[];
  details: PermissionDetail;
}

export type ResourcePermission =
  | keyof typeof PERSONAL_DATA_PERMISSION_ENUM
  | keyof typeof LIFE_PENSION_PLAN_PERMISSION_ENUM
  | keyof typeof PENSION_PLAN_PERMISSION_ENUM
  | keyof typeof PERSON_PERMISSION_ENUM;

export class Resource {
  id: string;
  label: string;
  status: boolean;
  certificateId: string;
  details: PermissionDetail;
  permissions: ResourcePermission[];
}

export enum CONSENT_STATUS_ENUM {
  'REJECTED' = 'REJECTED',
  'AUTHORISED' = 'AUTHORISED',
  'EXPIRED' = 'EXPIRED',
  'AWAITING_AUTHORISATION' = 'AWAITING_AUTHORISATION',
  'CLOSED' = 'CLOSED',
  'REVOKED' = 'REVOKED'
}

export enum SHARING_STATUS_LABEL_ENUM {
  AUTHORISED = 'Ativo até ',
  EXPIRED = 'Vencido em ',
  CLOSED = 'Encerrado em ',
  REJECTED = 'Rejeitado em ',
  AWAITING_AUTHORISATION = 'Esperando autorização desde ',
  REVOKED = 'Revogado em '
}

export class TransmissionSharingDTO {
  id: string;
  participantName: string;
  thumbnail: string;
  status: keyof typeof SHARING_STATUS_LABEL_ENUM;
  expirationDate: Date;
}

export class ConsentDTO {
  id: string;
  statusDate: Date;
  expirationDate: Date;
  solicitationDate: Date;
  participant: Participant;
  personalData: PersonalData;
  personResources: Resource[];
  lifePensionResources: Resource[];
  pensionPlanResources: Resource[];
  status: keyof typeof CONSENT_STATUS_ENUM;
}

interface IRedirect {
  isHandOff: boolean;
  redirectTo: string;
}

export interface IErrorConsent {
  redirect: IRedirect;
  type: string;
  message: string;
  tpp: ITpp;
}

export interface ICompleteConsent {
  tpp: ITpp;
  redirect: IRedirect;
}

export interface ICompleteConsentResourcePayloadDTO {
  id: string;
  value: string;
  permissions: ResourcePermission[];
}

export interface ICompleteConsentPayloadDTO {
  commandId: string;
  consentId: string;
  createdOn: Date;
  expiredOn: Date;
  tppName: string;
  resources: ICompleteConsentResourcePayloadDTO[];
}
